export function parseError(errorResponse, t) {
  if (!errorResponse) return null;

  let errorObj = errorResponse;
  if (typeof errorResponse === "string") {
    try {
      errorObj = JSON.parse(errorResponse);
    } catch {
      return errorResponse;
    }
  }

  if (Array.isArray(errorObj.errors) && errorObj.errors.length > 0) {
    // Special handling for known codes
    const hasMissingProjectOrWorkOrder = errorObj.errors.some(
      (e) =>
        e.code === "ORA-20110" &&
        typeof e.message === "string" &&
        e.message.includes("PRJWOMANDATORY")
    );
    if (hasMissingProjectOrWorkOrder) {
      return t("errorUtils.missingProjectOrWorkOrder");
    }

    const hasKompBalanceBelowLimit = errorObj.errors.some(
      (e) =>
        e.code === "ORA-20110" &&
        typeof e.message === "string" &&
        e.message.includes("BELOWBALANCELIMIT") &&
        e.message.includes("The balance TELEKOMP is below the limit")
    );
    if (hasKompBalanceBelowLimit) {
      return t("errorUtils.kompBalanceBelowLimit");
    }

    const absenceExceedsScheduledHours = errorObj.errors.some(
      (e) =>
        e.code === "ORA-20110" &&
        typeof e.message === "string" &&
        e.message.includes("K099_31") &&
        e.message.includes("Absence cannot exceed scheduled hours")
    );
    if (absenceExceedsScheduledHours) {
      return t("errorUtils.absenceExceedsScheduledHours");
    }
  }

  return null;
}
